import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'eintracht_frankfurt';
const supportEmail = {
	[customerGroup]: 'info@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyAU9gvAA0Nfpf8OPamdH2SY2flBydAD_GY',
		authDomain: 'eintracht-app.firebaseapp.com',
		projectId: 'eintracht-app',
		storageBucket: 'eintracht-app.firebasestorage.app',
		messagingSenderId: '327027437479',
		appId: '1:327027437479:web:84892dd6eb0d1abacdd082',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['ch'],
	gaId: '',
	hasRecommendations: true,
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	defVenue: '691edf9c510b3a7ae115be56',
};

import 'zone.js';
